import { combineReducers } from "redux";
import authReducer from "./authReducer";
import dataReducer from "./dataReducer";
import messageReducer from "./messageReducer";
import notificationReducer from "./notificationReducer";
import productReducer from "./productReducer";
import inventoryReducer from "./inventoryReducer";

const rootReducer = combineReducers({
    auth: authReducer,
    data: dataReducer,
    product: productReducer,
    message: messageReducer,
    notification: notificationReducer,
    inventory: inventoryReducer,
})

export default rootReducer